export default __webpack_public_path__ + "static/4_20-5f5deec4343127fc3971036f0ab90434.png";